const ABObjectQueryCore = require("../core/ABObjectQueryCore");
module.exports = class ABObjectQuery extends ABObjectQueryCore {};
